import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import MahutiHeader from "../../components/mahuti-header/MahutiHeader";
import { resetSelections } from "../../store/MahutiReducer";
import { onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import './MahutiPaymentPage.css'
import { EVENT_IFRAME_BACK, EVENT_IFRAME_ONLOAD, PAGES, PREFIX_PATH, getCoverPhoto } from "../../utils/GlobalParams";
import { clearAll } from "../../utils/orderUtils";

export default function MahutiPaymentPage(props) {
    const [paymentUrl, setPaymentUrl] = useState("");
    const [iframeLoading, setIframeLoading] = useState(false)
    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const iframeRef = useRef(null);
    let iframe = document.createElement('iframe');
    iframe.src = '';
    let lpPrefix = store.lpName ? '/' + store.lpName : '';
    useEffect(() => {
        setPaymentUrl( store.apiIcreditGetURL );
        setIframeLoading(true)
        refreshIframeInterval()

        if (store.refresh && !store.apiIcreditGetURL && store.newPayment === true) {
            navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.ACTIVITY_FLOW + "#sellingFlow")
        }else if(store.refresh && !store.apiIcreditGetURL){
            //navigate(PREFIX_PATH + lpPrefix + '/');
        }else{
            window.scrollTo(0, 0);
        }

        return () => {
            
            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => { })
            //Set and an event handler for iFrame events
            const handler = (ev) => {

                if (typeof ev.data !== 'object') return
                if (!ev.data.type) return
                if (!ev.data.message) return
          
                if (ev.data.message === EVENT_IFRAME_BACK){ 
                    dispatch(resetSelections());
                    navigate(PREFIX_PATH + lpPrefix + '/');
                }

                if (ev.data.message === EVENT_IFRAME_ONLOAD){ 
                    navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.PAYMENT_PAGE + '/' + ev.data.orderId)
                    clearAll(dispatch)
                }
              }
          
              window.addEventListener('message', handler)

              //remove addEventListener
              return () => window.removeEventListener('message', handler)

        }
    }, [])

    const refreshIframeInterval = () => {
        console.log(iframeLoading)
        let iframeInt = setInterval( () => {
            iframeLoading ? setPaymentUrl( store.apiIcreditGetURL ) : clearInterval(iframeInt)
        }, 3000);
    }

    const handleOnload = () => {
        setIframeLoading(false)
    }
    return <>
        <div className="MahutiPaymentPage">
            
            { <header className="main-header">
                <MahutiHeader landingPageParams={props.landingPageParams} />
            </header> }
            {/* <PaymentSuccess /> */}
            <div className='cover-img' style={getCoverPhoto(store.lpParams?.Image__c)}>
                <div className="block">
                </div>
                <div className="header-cover-title mb-3">
                    סל קניות
                </div>
                <div className="container">
                    {/* {cartDetails && <MahutiTableDetails tableTitle='פרטי מוצר' {...cartDetails} visitors={store?.visitors} columns={['שם', 'מחיר', 'כמות']} />} */}
                    {/* <MahutiTableDetails tableTitle='פרטי חשבונית' /> */}
                    {iframeLoading && <div className="spinner-border" style={{color: '#F04D81', width: '4rem', height: '4rem', borderWidth: '6px'}} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                    {/*{paymentUrl && createIframe(iframeRef, paymentUrl, handleOnload)}*/}
                    {paymentUrl &&   <div id='myIframe' className='p-2'>
                                        <iframe id='icreditframe' ref={iframeRef} src={paymentUrl?.URL} title='PayNow' allowFullScreen onLoad={() => handleOnload()}></iframe>
                                    </div>}
                </div>
            </div>
            <div className="block-2"></div>
        </div>
        <Footer landingPageParams={props.landingPageParams} />
    </>
}


// const createIframe = (iframeRef, paymentURL, handleOnload) => {
//     return  <div id='myIframe' className='p-2'>
//                 <iframe id='icreditframe' ref={iframeRef} src={paymentURL?.URL} title='PayNow' allowFullScreen onLoad={() => handleOnload()}></iframe>
//             </div>
//
// }